export const IconCheckmark = ({ className }: { className?: string }) => (
  <svg width="64" height="64" viewBox="0 0 16 16" className={`fill-current ${className}`} xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.57388 12C6.3891 11.9994 6.21286 11.9221 6.08721 11.7866L2.84721 8.33996H2.84721C2.595 8.07118 2.60844 7.64884 2.87721 7.39663C3.14599 7.14442 3.56833 7.15785 3.82055 7.42663L6.56721 10.3533L12.1739 4.21996V4.21996C12.4044 3.93288 12.824 3.88705 13.1111 4.11759C13.3982 4.34813 13.444 4.76774 13.2135 5.05482C13.197 5.07534 13.1793 5.09487 13.1605 5.1133L7.06721 11.78C6.94274 11.9179 6.76634 11.9977 6.58055 12L6.57388 12Z"
    />
  </svg>
)
